import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { CompanySearchResult } from 'src/types/work_area';
import axiosInstance from 'src/utils/axios';

type CompanySearchResponse = { data: CompanySearchResult[] };

/**
 * Raw company search from API.
 * rootCompanyId: selected company (from CompanyTree) when set.
 * When omitted/null, API searches across all companies (super admin flow).
 * Mapping to UI shape is done in useWorkAreaCompanyUsersSearch.
 */
const useCompanyUsersSearchQuery = (searchTerm: string, rootCompanyId: number | null) => useQuery<CompanySearchResponse>({
    queryKey: queryKeys.workArea.companyUsersSearch(rootCompanyId, searchTerm),
    queryFn: async () => {
      const res = await axiosInstance.get<CompanySearchResult[]>(
        api.getCompanySearch(searchTerm.trim(), rootCompanyId)
      );
      return { data: res.data };
    },
    enabled: Boolean(searchTerm.trim()),
  });

export default useCompanyUsersSearchQuery;
